<template>
  <main>
    <v-card class="py-4">
      <v-card-title class="px-4">
        <h2>Refund</h2>
      </v-card-title>
      <formWrapper :validator="$v.form">
        <form @submit.prevent="handleSave" class="form-box">
          <v-card-text>
            <p>
              Reservation Price :
              <strong>{{
                reservationObj.price_after_discount || "" + " "
              }}</strong>
              {{ reservationObj.currency || "" }}
            </p>
            <p>
              <strong>Camp :</strong>
              {{ reservationObj.camp || "" }}
            </p>

            <v-row>
              <v-col md="6" cols="12">
                <form-group name="cashier_id" attribute="fields.cashier_id">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="cashiers"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.cashier_id"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col md="6" cols="12">
                <section class="increment-label">
                  <span>Refund Amount</span>
                  <number-input
                    center
                    v-model="form.refund_amount"
                    controls
                    :step="0.01"
                  ></number-input>
                </section>
              </v-col>
              <v-col cols="12" class="pt-0">
                <form-group name="notes" :attribute="`fields.notes`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model="form.notes"
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-5">
            <v-btn
              class="success text-capitalize"
              large
              rounded
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
            >
              <span>Save</span></v-btn
            >
            <v-btn color=" darken-1" text @click="cancel">Cancel</v-btn>
          </v-card-actions>
        </form>
      </formWrapper>
    </v-card>
    <!-- <printed-receipt :item="item" id="section-to-print"></printed-receipt> -->
  </main>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      form: {
        // reservation_id: this.reservationObj.id,
        cashier_id: "",
        refund_amount: null,
        notes: ""
      },
      cashiers: [],
      item: {}
    };
  },
  props: {
    reservationObj: {
      type: Object,
      default: () => {}
    }
  },
  // components: {
  //   PrintedReceipt: () =>
  //     import("@/views/bookings/reciepts/components/PrintedReceipt.vue")
  // },
  created() {
    this.indexCashiers();
  },
  methods: {
    indexCashiers() {
      IndexData({ reqName: `/lists` })
        .then(res => {
          this.cashiers = res.data.cashiers;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      StoreData({
        reqName: `reservations/refund`,
        data: { ...this.form, reservation_id: this.reservationObj.id }
      })
        .then(res => {
          // const { receipt } = res.data;
          this.item = res.data.receipt;
          this.$emit("closeDialog");

          StoreData({
            reqName: `/receipts/print`,
            data: { receipt_id: res.data.receipt.id }
          })
            .then(() => {})
            .catch(() => {});

          this.$emit("printData", this.item);
          this.$emit("reloadData");
          this.reset();
        })
        .catch(() => {})
        .finally(() => {});
    },
    cancel() {
      this.$emit("closeDialog");
    },
    reset() {
      this.form = {
        reservation_id: null,
        cashier_id: "",
        refund_amount: null,
        notes: ""
      };
      this.$v.form.$reset();
    }
  },
  validations: {
    form: {
      cashier_id: {
        required
      },
      refund_amount: {
        required
      },
      notes: {
        maxLength: maxLength(255)
      }
    }
  },
  watch: {
    refundDialog: {
      handler(val) {
        if (!val) {
          this.reset();
        }
      },
      immediate: true
    }
  }
};
</script>
